'use client'

import { formatFontFamily } from '@/lib/themeHelpers'
import { useScrollAnimation, scrollAnimationClasses } from '@/lib/useScrollAnimation'
import { Quote } from 'lucide-react'

interface TestimonialsSectionProps {
  surface: "dark" | "light";
  theme: any;
  fontFamily: string;
  gradStart: string;
  gradEnd: string;
  angle: number;
  content: any;
}

export default function TestimonialsSection({
  surface,
  theme,
  fontFamily,
  gradStart,
  gradEnd,
  angle,
  content
}: TestimonialsSectionProps) {
  const { ref: quoteRef, isVisible: quoteVisible } = useScrollAnimation();
  
  const backgroundStyle = {
    backgroundImage: surface === "dark" 
      ? `linear-gradient(${angle}deg, ${gradStart}, ${gradEnd})`
      : `linear-gradient(${angle}deg, #f8f9fa, #e9ecef)`,
    fontFamily: formatFontFamily(fontFamily)
  };

  const communityQuote = content.communityQuote;
  

  return (
    <section className="relative w-full" style={backgroundStyle}>
      <div className="mx-auto max-w-4xl px-6 py-12 lg:px-8">
        {/* Community Quote */}
        <div 
          ref={quoteRef as React.RefObject<HTMLDivElement>}
          className={`text-center ${scrollAnimationClasses.transition} ${quoteVisible ? scrollAnimationClasses.visible : scrollAnimationClasses.hidden}`}
        >
          {/* Quote Icon */}
          <div 
            className="inline-flex items-center justify-center w-10 h-10 mb-4 rounded-full"
            style={{ 
              background: `linear-gradient(135deg, hsl(var(--primary)), hsl(var(--primary) / 0.8))`,
            }}
          >
            <Quote className="w-4 h-4 text-white" />
          </div>
          
          {/* Quote Text */}
          <blockquote 
            className="text-xl md:text-2xl font-medium leading-relaxed mb-4 font-primary"
            style={{ color: theme.text }}
          >
            "{communityQuote.quote}"
          </blockquote>
          
          {/* Attribution */}
          <p 
            className="text-sm font-medium uppercase tracking-wider mb-6 font-primary"
            style={{ color: theme.mutedText }}
          >
            — {communityQuote.attribution}
          </p>
        </div>
      </div>
    </section>
  );
}
